window.addEventListener('DOMContentLoaded', () => {
  const burger = document.querySelector('.shifter-handle');
  const body = document.querySelector('body');
  const page = document.querySelector('.shifter-page');
  if(burger) {
    burger.addEventListener('click', () => {
      if(body) {      
        body.classList.add('shifter-enabled');
        body.classList.add('shifter-open');
      }
    })
    document.addEventListener('click', (e) => {
      if(e.target == page && e.target != burger) {
        body.classList.remove('shifter-enabled');
        body.classList.remove('shifter-open');
      }
    })
  }
})